import React from 'react';
import { COLORS, Icon } from '@livecommerce/design-system';
import { styled } from '@linaria/react';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import HeaderItem from './HeaderItem.jsx';

const HeaderItemContents = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
`;

const noop = () => {};

const HelpItem = () => {
  const { t } = useLocalization();

  // This button is controlled externally via Pendo, so it has no onClick handler.

  return (
    <HeaderItem
      label={t('globalHelp.entrypointLabel')}
      onClick={noop} // onClick hander makes the HeaderItem render as a clickable item
      id="help-resource-button"
    >
      <HeaderItemContents>
        <Icon name="help" color={COLORS.orange_500} />
      </HeaderItemContents>
    </HeaderItem>
  );
};

export default HelpItem;
